import { useContext, useState } from "react";
import AppContext from "../../contexts/AppContext";
import apiFetch from "../../helperFunctions/api";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export default function RaidTeamTable({ data: rows }) {
  const { API, setRaidTeams, setCharacters, setLedgerData } = useContext(AppContext);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");

  async function handleDelete() {
    if (deleting || !selectedTeam) return;
    setDeleting(true);
    setError("");
    try {
      const response = await apiFetch(`${API}/raidteam/${selectedTeam.id}`, { method: "DELETE" });
      if (!response.ok) {
        const details = await response.json();
        throw new Error(details.message || "Unable to delete raid team.");
      }
      const unassign = (records) => records.map((record) =>
        record.raid_team === selectedTeam.id ? { ...record, raid_team: null } : record
      );
      setRaidTeams((teams) => teams.filter((team) => team.id !== selectedTeam.id));
      setCharacters(unassign);
      setLedgerData(unassign);
      setSelectedTeam(null);
    } catch (err) {
      console.error("Error deleting raid team:", err);
      setError(err instanceof SyntaxError ? "Unable to delete raid team. Please try again." : err.message);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">ID</TableCell>
            <TableCell align="center">Raid Team</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="center" component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell align="center">{row.name}</TableCell>
              <TableCell align="center">
                <Button variant="contained" color="error" onClick={() => {
                  setError("");
                  setSelectedTeam(row);
                }}>Delete Raid Team</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <Dialog open={selectedTeam !== null} onClose={() => {
      if (!deleting) setSelectedTeam(null);
    }} aria-labelledby="delete-raid-team-title">
      <DialogTitle id="delete-raid-team-title">Delete Raid Team?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Delete {selectedTeam?.name}? Characters will be unassigned. Ledger history and DKP balances
          will be retained, but the team association will be removed, including in active sessions.
          This cannot be undone.
        </DialogContentText>
        {error && <Alert severity="error">{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button disabled={deleting} onClick={() => setSelectedTeam(null)}>Cancel</Button>
        <Button color="error" disabled={deleting} onClick={handleDelete}>
          {deleting ? "Deleting..." : "Confirm Delete"}
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
}